The response from the `updateUploadedCandidatePerson` mutation.
